import { render, staticRenderFns } from "./LifestyleForm.vue?vue&type=template&id=64d61d12&scoped=true"
import script from "./LifestyleForm.vue?vue&type=script&lang=js"
export * from "./LifestyleForm.vue?vue&type=script&lang=js"
import style0 from "./LifestyleForm.vue?vue&type=style&index=0&id=64d61d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d61d12",
  null
  
)

export default component.exports